/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Home, Eye, EyeOff, RefreshCw, LogOut, Edit2, Save, X, Upload, Download, Volume2, Sparkles, Hash, Trophy, FileDown, FileUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { API, BACKEND_URL, resolveUrl, useAdmin } from "../adminShared";
import { PlacementEditor } from "../PlacementEditor";
import { VotingColumnEditor } from "../VotingColumnEditor";

export const ImagesSection = () => {
  const {
    countries, setCountries, votes, setVotes, events, setEvents,
    activeEvent, setActiveEvent, showCreateEvent, setShowCreateEvent, newEventName, setNewEventName,
    copyFromEventId, setCopyFromEventId, creatingEvent, setCreatingEvent, showRenameEvent, setShowRenameEvent,
    renameEventName, setRenameEventName, importFile, setImportFile, showImportConfirm, setShowImportConfirm,
    importing, setImporting, newCountry, setNewCountry, editingCountry, setEditingCountry,
    backgroundVideo, setBackgroundVideo, bgVideoBlur, setBgVideoBlur, bgVideoBrightness, setBgVideoBrightness, bgVideoOpacity, setBgVideoOpacity, fontTitle, setFontTitle, fontSubtitle, setFontSubtitle,
    fontCountry, setFontCountry, fontPoints, setFontPoints, fontVoting, setFontVoting,
    customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName, customFontSubtitleUrl, setCustomFontSubtitleUrl,
    customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl, customFontCountryName, setCustomFontCountryName,
    customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName, customFontVotingUrl, setCustomFontVotingUrl,
    customFontVotingName, setCustomFontVotingName, fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle,
    fontSizeCountry, setFontSizeCountry, fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    rowBgEven, setRowBgEven, rowBgOdd, setRowBgOdd, rowBgEvenTranslucent, setRowBgEvenTranslucent, rowBgOddTranslucent, setRowBgOddTranslucent, rowBadgeTranslucent, setRowBadgeTranslucent, logoUrl, setLogoUrl,
    logoPosition, setLogoPosition, logoSize, setLogoSize, logoZIndex, setLogoZIndex,
    logoOpacity, setLogoOpacity, extraImage1Url, setExtraImage1Url, extraImage1Position, setExtraImage1Position,
    extraImage1Size, setExtraImage1Size, extraImage1ZIndex, setExtraImage1ZIndex, extraImage1Opacity, setExtraImage1Opacity,
    extraImage2Url, setExtraImage2Url, extraImage2Position, setExtraImage2Position, extraImage2Size, setExtraImage2Size,
    extraImage2ZIndex, setExtraImage2ZIndex, extraImage2Opacity, setExtraImage2Opacity, extraImage3Url, setExtraImage3Url,
    extraImage3Position, setExtraImage3Position, extraImage3Size, setExtraImage3Size, extraImage3ZIndex, setExtraImage3ZIndex,
    extraImage3Opacity, setExtraImage3Opacity, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, positionBadgeTranslucent, setPositionBadgeTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, mystery12Text, setMystery12Text, mysteryHiddenPoints, setMysteryHiddenPoints, voteDisplayColumns, setVoteDisplayColumns,
    showVoterBorder, setShowVoterBorder, showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary,
    fontTitleItalic, setFontTitleItalic, fontSubtitleItalic, setFontSubtitleItalic, fontCountryItalic, setFontCountryItalic,
    fontPointsItalic, setFontPointsItalic, fontVotingItalic, setFontVotingItalic, fontVotingSecondaryItalic, setFontVotingSecondaryItalic,
    customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl, customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled,
    overlay12DurationMode, setOverlay12DurationMode, overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle,
    overlay12BgColor, setOverlay12BgColor, overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives,
    overlay12UseAdminColors, setOverlay12UseAdminColors, overlay12ShowConfetti, setOverlay12ShowConfetti, overlay12Visible, setOverlay12Visible, previewGiverId, setPreviewGiverId,
    previewRecipientId, setPreviewRecipientId, winnerOverlayEnabled, setWinnerOverlayEnabled, winnerOverlayDurationMode, setWinnerOverlayDurationMode,
    winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle, winnerOverlayBgColor, setWinnerOverlayBgColor,
    winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText, winnerOverlaySubtitleText, setWinnerOverlaySubtitleText,
    winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti, winnerOverlayShowPoints, setWinnerOverlayShowPoints,
    winnerOverlayVisible, setWinnerOverlayVisible, overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle,
    overlay12FontCountry, setOverlay12FontCountry, overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale,
    winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle, winnerOverlayFontCountry, setWinnerOverlayFontCountry,
    winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale, loading, setLoading,
    exportingPdf, setExportingPdf, winnerPreviewId, setWinnerPreviewId, adminInitRef, adminPollRef,
    navigate, fetchCurrentVoterStatus, handleHideOverlay12, handlePreviewOverlay12, handleShowWinner, handleHideWinner,
    getFontFormat, fetchBackground, handleSetBackground, handleExportPdf, handleFileUpload, fetchCountries,
    fetchVotes, downloadFromApi, handleExportVotesPdf, handleExportVotesExcel, fetchEvents, reloadEventData,
    handleSelectEvent, handleCreateEvent, handleRenameEvent, handleExportEvent, handleImportEvent, handleAddCountry,
    handleDeleteCountry, handleSetCurrentVoter, handleResetVotes, handleLogout, handleApplyVotes, handleReveal12Points,
    handleEditCountry, handleUpdateCountry, handleToggleBadge, handleToggleTranslucent, votingCountries, juryMembers,
    votedCountries,
  } = useAdmin();
  // Convert a hex/rgba color string into a #rrggbb value usable by <input type="color">.
  const toPickerHex = (c) => {
    if (!c || typeof c !== 'string') return "#000000";
    if (c.startsWith('#')) return c.slice(0, 7).padEnd(7, '0');
    const m = c.match(/rgba?\(([^)]+)\)/i);
    if (m) {
      const parts = m[1].split(',').map((s) => parseInt(s.trim(), 10));
      const h = (n) => Math.max(0, Math.min(255, isNaN(n) ? 0 : n)).toString(16).padStart(2, '0');
      return `#${h(parts[0])}${h(parts[1])}${h(parts[2])}`;
    }
    return "#000000";
  };
  return (
    <>
                {/* Logo */}
                <div>
                  <Label htmlFor="logo-url" className="text-zinc-300 mb-2 block font-semibold">Logo del Evento</Label>
                  <Input
                    id="logo-url"
                    data-testid="input-logo-url"
                    value={logoUrl}
                    onChange={(e) => setLogoUrl(e.target.value)}
                    className="bg-zinc-800 border-zinc-700 text-white mb-2"
                    placeholder="URL o sube archivo"
                  />
                  
                  <div className="mb-3">
                    <input
                      type="file"
                      id="logo-file"
                      accept="image/*"
                      className="hidden"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file) await handleFileUpload(file, 'logo');
                      }}
                    />
                    <Button
                      type="button"
                      onClick={() => document.getElementById('logo-file').click()}
                      variant="outline"
                      className="w-full bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                    >
                      <Upload className="w-4 h-4 mr-2" />
                      Subir Logo desde Archivo
                    </Button>
                  </div>
                  
                  {/* Logo Preview */}
                  {logoUrl && (
                    <div className="flex items-center gap-3 p-2 bg-zinc-900 rounded-lg mb-3">
                      <img 
                        src={resolveUrl(logoUrl)}
                        alt="Logo preview"
                        className="h-12 w-auto object-contain"
                        onError={(e) => e.target.style.display = 'none'}
                      />
                      <span className="text-zinc-400 text-sm">Vista previa del logo</span>
                    </div>
                  )}
                  
                  <Label className="text-zinc-300 mb-2 block">Posición del Logo</Label>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                    <button
                      type="button"
                      data-testid="logo-pos-top-left"
                      onClick={() => setLogoPosition("top-left")}
                      className={`p-3 rounded-lg border transition-all ${
                        logoPosition === "top-left"
                          ? 'bg-pink-600 border-pink-500 text-white'
                          : 'bg-zinc-800 border-zinc-700 text-zinc-300 hover:border-zinc-600'
                      }`}
                    >
                      ↖ Superior Izq.
                    </button>
                    <button
                      type="button"
                      data-testid="logo-pos-top-right"
                      onClick={() => setLogoPosition("top-right")}
                      className={`p-3 rounded-lg border transition-all ${
                        logoPosition === "top-right"
                          ? 'bg-pink-600 border-pink-500 text-white'
                          : 'bg-zinc-800 border-zinc-700 text-zinc-300 hover:border-zinc-600'
                      }`}
                    >
                      ↗ Superior Der.
                    </button>
                    <button
                      type="button"
                      data-testid="logo-pos-bottom-left"
                      onClick={() => setLogoPosition("bottom-left")}
                      className={`p-3 rounded-lg border transition-all ${
                        logoPosition === "bottom-left"
                          ? 'bg-pink-600 border-pink-500 text-white'
                          : 'bg-zinc-800 border-zinc-700 text-zinc-300 hover:border-zinc-600'
                      }`}
                    >
                      ↙ Inferior Izq.
                    </button>
                    <button
                      type="button"
                      data-testid="logo-pos-bottom-right"
                      onClick={() => setLogoPosition("bottom-right")}
                      className={`p-3 rounded-lg border transition-all ${
                        logoPosition === "bottom-right"
                          ? 'bg-pink-600 border-pink-500 text-white'
                          : 'bg-zinc-800 border-zinc-700 text-zinc-300 hover:border-zinc-600'
                      }`}
                    >
                      ↘ Inferior Der.
                    </button>
                    <button
                      type="button"
                      data-testid="logo-pos-top-center"
                      onClick={() => setLogoPosition("top-center")}
                      className={`p-3 rounded-lg border transition-all col-span-2 ${
                        logoPosition === "top-center"
                          ? 'bg-pink-600 border-pink-500 text-white'
                          : 'bg-zinc-800 border-zinc-700 text-zinc-300 hover:border-zinc-600'
                      }`}
                    >
                      ↑ Superior Centro
                    </button>
                  </div>
                  <div className="grid grid-cols-3 gap-4 mt-3">
                    <div>
                      <Label className="text-zinc-400 text-xs mb-1 block">Tamaño: {logoSize}px</Label>
                      <input type="range" min="20" max="400" value={logoSize} onChange={(e) => setLogoSize(Number(e.target.value))} className="w-full accent-pink-500" />
                    </div>
                    <div>
                      <Label className="text-zinc-400 text-xs mb-1 block">Capa (z-index): {logoZIndex}</Label>
                      <input type="range" min="0" max="100" value={logoZIndex} onChange={(e) => setLogoZIndex(Number(e.target.value))} className="w-full accent-pink-500" />
                    </div>
                    <div>
                      <Label className="text-zinc-400 text-xs mb-1 block">Opacidad: {logoOpacity}%</Label>
                      <input type="range" min="0" max="100" value={logoOpacity} onChange={(e) => setLogoOpacity(Number(e.target.value))} className="w-full accent-pink-500" />
                    </div>
                  </div>
                </div>

                {/* Extra Images 1-3 */}
                {[
                  { label: "Imagen Extra 1", url: extraImage1Url, setUrl: setExtraImage1Url, pos: extraImage1Position, setPos: setExtraImage1Position, size: extraImage1Size, setSize: setExtraImage1Size, zIdx: extraImage1ZIndex, setZIdx: setExtraImage1ZIndex, opacity: extraImage1Opacity, setOpacity: setExtraImage1Opacity, id: "extra1" },
                  { label: "Imagen Extra 2", url: extraImage2Url, setUrl: setExtraImage2Url, pos: extraImage2Position, setPos: setExtraImage2Position, size: extraImage2Size, setSize: setExtraImage2Size, zIdx: extraImage2ZIndex, setZIdx: setExtraImage2ZIndex, opacity: extraImage2Opacity, setOpacity: setExtraImage2Opacity, id: "extra2" },
                  { label: "Imagen Extra 3", url: extraImage3Url, setUrl: setExtraImage3Url, pos: extraImage3Position, setPos: setExtraImage3Position, size: extraImage3Size, setSize: setExtraImage3Size, zIdx: extraImage3ZIndex, setZIdx: setExtraImage3ZIndex, opacity: extraImage3Opacity, setOpacity: setExtraImage3Opacity, id: "extra3" }
                ].map(({ label, url, setUrl, pos, setPos, size, setSize, zIdx, setZIdx, opacity, setOpacity, id }) => (
                  <div key={id} className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700">
                    <Label className="text-zinc-300 mb-2 block font-semibold">{label}</Label>
                    <div className="flex gap-2 mb-2">
                      <Input
                        data-testid={`input-${id}-url`}
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        className="bg-zinc-800 border-zinc-700 text-white flex-1"
                        placeholder="URL de imagen o GIF"
                      />
                      <input
                        type="file"
                        accept="image/*,image/gif"
                        id={`file-input-${id}`}
                        className="hidden"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (!file) return;
                          const formData = new FormData();
                          formData.append('file', file);
                          try {
                            const response = await axios.post(`${API}/upload`, formData, {
                              headers: { 'Content-Type': 'multipart/form-data' }
                            });
                            setUrl(`${BACKEND_URL}${response.data.url}`);
                            toast.success("Imagen subida");
                          } catch (err) { toast.error("Error al subir"); }
                          e.target.value = '';
                        }}
                      />
                      <Button
                        type="button"
                        variant="outline"
                        className="border-zinc-700 text-zinc-300"
                        data-testid={`btn-upload-${id}`}
                        onClick={() => document.getElementById(`file-input-${id}`).click()}
                      >
                        <Upload className="w-4 h-4 mr-1" /> Subir
                      </Button>
                      {url && (
                        <Button type="button" variant="ghost" size="icon" className="text-red-400" onClick={() => setUrl("")}>
                          <X className="w-4 h-4" />
                        </Button>
                      )}
                    </div>
                    {url && (
                      <div className="flex items-center gap-3 mb-3 p-2 bg-zinc-900/50 rounded-lg border border-zinc-800">
                        <img src={resolveUrl(url)} alt={label} style={{ height: `${Math.min(size, 80)}px` }} className="object-contain rounded" onError={(e) => e.target.style.display='none'} />
                        <span className="text-zinc-400 text-sm">Vista previa ({size}px, capa {zIdx}, {opacity}%)</span>
                      </div>
                    )}
                    <div className="grid grid-cols-2 gap-2 mb-3">
                      {[
                        { val: "top-left", text: "↖ Superior Izq." },
                        { val: "top-right", text: "↗ Superior Der." },
                        { val: "bottom-left", text: "↙ Inferior Izq." },
                        { val: "bottom-right", text: "↘ Inferior Der." }
                      ].map(({ val, text }) => (
                        <button
                          key={val}
                          type="button"
                          data-testid={`${id}-pos-${val}`}
                          onClick={() => setPos(val)}
                          className={`p-2 rounded-lg border transition-all text-sm ${
                            pos === val
                              ? 'bg-pink-600 border-pink-500 text-white'
                              : 'bg-zinc-800 border-zinc-700 text-zinc-300 hover:border-zinc-600'
                          }`}
                        >{text}</button>
                      ))}
                      <button
                        type="button"
                        data-testid={`${id}-pos-top-center`}
                        onClick={() => setPos("top-center")}
                        className={`p-2 rounded-lg border transition-all text-sm col-span-2 ${
                          pos === "top-center"
                            ? 'bg-pink-600 border-pink-500 text-white'
                            : 'bg-zinc-800 border-zinc-700 text-zinc-300 hover:border-zinc-600'
                        }`}
                      >↑ Superior Centro</button>
                    </div>
                    <div className="grid grid-cols-3 gap-4">
                      <div>
                        <Label className="text-zinc-400 text-xs mb-1 block">Tamaño: {size}px</Label>
                        <input type="range" min="20" max="400" value={size} onChange={(e) => setSize(Number(e.target.value))} className="w-full accent-pink-500" />
                      </div>
                      <div>
                        <Label className="text-zinc-400 text-xs mb-1 block">Capa (z-index): {zIdx}</Label>
                        <input type="range" min="0" max="100" value={zIdx} onChange={(e) => setZIdx(Number(e.target.value))} className="w-full accent-pink-500" />
                      </div>
                      <div>
                        <Label className="text-zinc-400 text-xs mb-1 block">Opacidad: {opacity}%</Label>
                        <input type="range" min="0" max="100" value={opacity} onChange={(e) => setOpacity(Number(e.target.value))} className="w-full accent-pink-500" />
                      </div>
                    </div>
                  </div>
                ))}

                {/* Editor visual de colocación (arrastrar/redimensionar con vista previa) */}
                <PlacementEditor />

                {/* Foto de Artista por Defecto */}
                <div>
                  <Label htmlFor="default-artist-photo" className="text-zinc-300 mb-2 block font-semibold">Foto de Artista por Defecto</Label>
                  <p className="text-zinc-500 text-sm mb-2">Se mostrará cuando un país no tenga foto de artista configurada</p>
                  <Input
                    id="default-artist-photo"
                    data-testid="input-default-artist-photo"
                    value={defaultArtistPhoto}
                    onChange={(e) => setDefaultArtistPhoto(e.target.value)}
                    className="bg-zinc-800 border-zinc-700 text-white mb-2"
                    placeholder="URL o sube archivo"
                  />
                  
                  <div className="mb-3">
                    <input
                      type="file"
                      id="default-artist-file"
                      accept="image/*"
                      className="hidden"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (file) await handleFileUpload(file, 'defaultArtist');
                      }}
                    />
                    <Button
                      type="button"
                      onClick={() => document.getElementById('default-artist-file').click()}
                      variant="outline"
                      className="w-full bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                    >
                      <Upload className="w-4 h-4 mr-2" />
                      Subir Foto por Defecto
                    </Button>
                  </div>
                  
                  {/* Preview */}
                  {defaultArtistPhoto && (
                    <div className="flex items-center gap-3 p-2 bg-zinc-900 rounded-lg">
                      <img 
                        src={resolveUrl(defaultArtistPhoto)}
                        alt="Foto por defecto"
                        className="w-16 h-16 rounded-full object-cover border-2 border-pink-500"
                        onError={(e) => e.target.style.display = 'none'}
                      />
                      <span className="text-zinc-400 text-sm">Vista previa de la foto por defecto</span>
                    </div>
                  )}
                </div>

                {/* Tamaño de Foto del Artista */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700">
                  <Label className="text-zinc-300 mb-3 block font-semibold text-lg">Tamaño de Foto/Vídeo del Artista</Label>
                  <p className="text-zinc-500 text-sm mb-4">Configura el tamaño del cuadrado de la foto del artista en la zona de votación</p>
                  
                  <div className="space-y-4">
                    <div className="flex gap-4">
                      <button
                        type="button"
                        onClick={() => setArtistPhotoSizeMode("adaptive")}
                        className={`flex-1 p-3 rounded-lg border transition-all ${
                          artistPhotoSizeMode === "adaptive"
                            ? 'bg-pink-600 border-pink-500 text-white'
                            : 'bg-zinc-800 border-zinc-700 text-zinc-300 hover:border-zinc-600'
                        }`}
                      >
                        Adaptable (100% ancho)
                      </button>
                      <button
                        type="button"
                        onClick={() => setArtistPhotoSizeMode("fixed")}
                        className={`flex-1 p-3 rounded-lg border transition-all ${
                          artistPhotoSizeMode === "fixed"
                            ? 'bg-pink-600 border-pink-500 text-white'
                            : 'bg-zinc-800 border-zinc-700 text-zinc-300 hover:border-zinc-600'
                        }`}
                      >
                        Fijo (px)
                      </button>
                    </div>
                    
                    {artistPhotoSizeMode === "fixed" && (
                      <div>
                        <Label className="text-zinc-300 mb-2 block">Tamaño en píxeles: {artistPhotoSizePx}px</Label>
                        <div className="flex gap-3 items-center">
                          <input
                            type="range"
                            min="100"
                            max="600"
                            value={artistPhotoSizePx}
                            onChange={(e) => setArtistPhotoSizePx(Number(e.target.value))}
                            className="flex-1 h-2 bg-zinc-700 rounded-lg appearance-none cursor-pointer accent-pink-500"
                          />
                          <Input
                            type="number"
                            value={artistPhotoSizePx}
                            onChange={(e) => setArtistPhotoSizePx(Number(e.target.value))}
                            className="w-24 bg-zinc-800 border-zinc-700 text-white"
                            min="100"
                            max="600"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
    </>
  );
};
